module.exports = __webpack_public_path__ + "img/468-5c9a07.png";